import { useEffect, useMemo, useRef, useState } from 'react';
import { deepCopy, isEqual, isUndef, urlParams } from '@lhb/func';
import { useMethods } from '@lhb/hook';
import useUpdateEffect from '@/common/hook/updateEffect/useUpdateEffect';
import { useDebounceEffect } from '@/common/hook/useEffectDebounce';
// import { geUnderTheDistrictPagingData as getLcnPlaceList } from '@/common/api/networkplan';
import { getLcnPlaceList } from '../api';
// import { sortRuleAliasOptions } from '../ts-config';
// import { businessStatus } from './SiteView/ts-config';
import { BUSINESS_ZOOM, CITY_LEVEL, DISTRICT_LEVEL, PROVINCE_LEVEL } from '@/common/components/AMap/ts-config';
import V2Message from '@/common/components/Others/V2Hint/V2Message';

/**
 * @Description 加载地图数据
 * 1.省市区聚合数据 --  clusterDataInMap
 * 2.点位数据（也是列表数据） --  listData
 * 3.围栏数据 --  polygonData
 * 5.市场容量统计数据 -- rightTopInfo
 */
const LoadMapData = ({
  isPositioning,
  mapIns,
  level,
  searchParams,
  isReset,
  setItemData,
  isOpenBorder,
  viewLevel,
  pointDataIds,
}) => {

  const { requirementId } = urlParams(location.search) || {}; // 需求id

  const [listData, setListData] = useState<any[]>([]); // 当前地图上的开店区域数据（点位、列表都使用）--处理后的数据
  const [polygonData, setPolygonData] = useState<any[]>([]);// 围栏数据--top绘制的时候需要判断是否重叠
  const [portData, setPortData] = useState<any[]>([]); // 当前地图上的开店区域原始数据--未处理（地图-统一）
  const [isLoading, setIsLoading] = useState<boolean>(true);// 右侧数据是否在加载中--右侧loading，跟随pageList接口请求
  const [isTargetRailZoom, setIsTargetRailZoom] = useState<boolean>(false);// 是否在显示围栏范围级别内
  const [rightTopInfo, setRightTopInfo] = useState<any>({
    isLoading: true,
    forecastCount: 0,
    total: 0
  });// 市场容量模式下，顶部信息--right使用
  // const lastBoundsRef = useRef<any>();// 上一次的屏幕边界

  const commonParamsRef = useRef<any>();// 缓存上一次的mapParams

  // 处理地图参数
  const mapParams = useMemo(() => {
    let _mapParams:any = { level };
    // 未选择现在去，且city为null，即点位在海外
    if (isUndef(viewLevel?.cityId)) {
      return null;
    }
    // 筛选项未选择行政区
    if (viewLevel?.provinceId && level >= PROVINCE_LEVEL) {
      _mapParams = { ..._mapParams, provinceIds: [viewLevel?.provinceId] };
    };
    if (viewLevel?.cityId && level >= CITY_LEVEL) {
      _mapParams = { ..._mapParams, cityIds: [viewLevel?.cityId] };
    }
    return _mapParams;

  }, [level, viewLevel?.cityId]);

  // 获取省市区的聚合数据
  // const loadClusterData = async (params: any) => {
  //   const listData = await industryCircleClusterList({
  //     ...params,
  //     isSelectMap: true, // 表明是选址地图-不受权限控制
  //   });
  //   setClusterDataInMap(isArray(listData) ? listData : []);
  // };

  /** 完整的筛选参数，将提供给场地、点位筛选 */
  const fullSearchParams = {
    ...mapParams,
    ...searchParams,
  };

  useDebounceEffect(() => {
    if (isPositioning) return; // 正在定位中，此时不执行以下逻辑
    if (!mapIns) return;
    const params = deepCopy(fullSearchParams);
    // 如果不存在level，说明mapParams中返回了null,点位在海外
    if (!params?.level) return;
    if (isEqual(commonParamsRef.current, {
      ...params,
      isReset: isReset || 0
    })) return;
    commonParamsRef.current = {
      ...params,
      isReset: isReset || 0,
    };
    if (level < DISTRICT_LEVEL) { // 获取聚合数据
      // loadClusterData(params);
    }
    if (level >= CITY_LEVEL) { // 获取区域下的数据
      setIsLoading(true);
      methods.loadDistrictData(params);
    }
  }, [mapIns, searchParams, mapParams, isPositioning, isReset], 300);

  useUpdateEffect(() => {
    if (!portData?.length && !isPositioning) {
      V2Message.warning('暂无数据');
    }
    // const { sortRule } = searchParams;
    // let rankKey = 'marketScore';

    // sortRuleAliasOptions.map((item) => {
    //   if (sortRule === item.id) {
    //     rankKey = item.key;
    //   }
    // });
    // 不做排序，因为接口已经做了排序
    // // 前端处理排序，根据marketScore排序，如果marketScore相同，取id小的在前
    // function compare(a, b) {
    //   // 如果不存在这个字段数据，则默认为0
    //   if (!a?.[rankKey]) {
    //     a[rankKey] = 0;
    //   }
    //   if (!b?.[rankKey]) {
    //     b[rankKey] = 0;
    //   }
    //   if (a?.status === businessStatus.NEW) {
    //     a[rankKey] = -1;
    //   }
    //   if (b?.status === businessStatus.NEW) {
    //     b[rankKey] = -1;
    //   }
    //   if (a?.[rankKey] !== b?.[rankKey]) {
    //     return b?.[rankKey] - a?.[rankKey];
    //   }
    //   // 如果是其他的排序字段，且数据相等，则再用marketScore排序
    //   if (rankKey !== 'marketScore') {
    //     if (a?.marketScore !== b?.marketScore) {
    //       return b?.marketScore - a?.marketScore;
    //     }
    //   }
    //   return b.id - a.id;
    // }

    const res = portData.map((item, index) => ({ ...item, rank: index }));
    // 每次触发接口更新时，重置初始化参数
    setItemData((state) => ({ ...state, isFirst: false }));
    !isPositioning && setIsLoading(false);

    // 当在level3的时候 点击右侧，那么会缩放到具体的点位导致level为4，level变化会触发portData变化，但实际数据并没有改变，所以此处不重新setDistrictData，因此不会引起其他地图重复监听districtData
    if (isEqual(res, listData)) return;
    setListData(res);
  }, [portData]);

  // 判断当前zoom是否可显示商圈围栏
  useEffect(() => {
    if (!mapIns) return;
    // 监听地图zoom的变化，到指定的zoom时，显示围栏
    mapIns.on('zoomend', () => {
      const zoom = mapIns.getZoom();
      setIsTargetRailZoom(zoom >= BUSINESS_ZOOM);
    });
  }, [mapIns]);

  useDebounceEffect(() => {
    const params = deepCopy(fullSearchParams);

    // 不显示围栏
    if (!isOpenBorder || !params?.level || !isTargetRailZoom) {
      setPolygonData([]);
      return;
    }
    if (pointDataIds?.length) {
      methods.loadPolygon(params);
    }
  }, [pointDataIds, searchParams, mapParams, isReset, isOpenBorder, isTargetRailZoom], 300);

  const methods = useMethods({

    // 获取区级以下的数据(分页接口，通过并行请求及递归获取全量数据)
    loadDistrictData: async (
      params,
      curPage = 1,
      lastData:any[] = []
    ) => {
      const size = 500; // 由接口调试后得出的分页size
      const _params = {
        ...params,
        requirementId,
        showPolygon: true,
        onlyLatLng: true, // 返回的数据只包含经纬度（数据量大的时候该参数设为true，提升接口响应速度），该参数会在第一次请求时被设为false，用来判断是否需要聚合
        size,
        isSelectMap: true, // 表明是选址地图-不受权限控制
      };

      // onlyLatLng的参数说明，如果返回的数据超过size的大小，此时需要聚合，故需要的数据仅仅是经纬度，因为是分页接口，为了提升速度，并行请求3条，如果依然有数据，递归调用
      if (!(level >= CITY_LEVEL && params?.cityIds?.length)) {
        setIsLoading(false);
        return;
      };
      setRightTopInfo((state) => ({
        ...state,
        isLoading: true
      }));

      Promise.all([
        getLcnPlaceList({ ..._params, page: curPage }),
        getLcnPlaceList({ ..._params, page: curPage + 1 }),
        getLcnPlaceList({ ..._params, page: curPage + 2 }),
      ]).then((res) => {
        if (!isEqual(commonParamsRef.current, {
          ...params,
          isReset: commonParamsRef.current.isReset
        })) {
          methods.loadDistrictData(commonParamsRef.current, 1, []);
          return;
        }
        const newArr = [...lastData, ...res[0], ...res[1], ...res[2]];
        // 最后一个请求依然有size的数据，可能还有更大的页数，进行递归调用
        // curPage最大15页，超过15页后不请求
        if (res[2]?.length === size && curPage <= 15) {
          methods.loadDistrictData(params, curPage + 3, newArr);
          return;
        }
        setPortData(newArr);
      }).finally(() => {
        // setIsLoading(false);
        setRightTopInfo((state) => ({
          ...state,
          isLoading: false
        }));
      });
    },

    // 获取围栏
    loadPolygon: async (params = {}) => {
      // 必须传区id
      const _params = {
        ...params,
        ids: pointDataIds,
        size: pointDataIds?.length,
        showPolygon: true,
        onlyLatLng: false, // 返回的数据只包含经纬度（数据量大的时候该参数设为true，提升接口响应速度），该参数会在第一次请求时被设为false，用来判断是否需要聚合
        isSelectMap: true, // 表明是选址地图-不受权限控制
      };
      const arr = await getLcnPlaceList(_params);
      setPolygonData(arr);
    },
  });

  return {
    portData,
    polygonData,
    districtData: listData,
    isLoading,
    rightTopInfo,
    mapParams,
    fullSearchParams,
  };
};
export default LoadMapData;


